module.exports = __webpack_public_path__ + "img/FlightsAdmin.743ce3e7.png";